export const MAX_GRID_ITEM_SIZE = 12;
export const DEFAULT_LONG_SUBTITLE_LENGTH = 80;